import type { CSSProperties } from 'react';
import { Loader2 } from 'lucide-react';
import { formatCountdown } from '../approval.timer';
import { StyledQrCode } from '../../qr/StyledQrCode';

type ApprovalQrPanelProps = {
  loading: boolean;
  qrCodeUrl: string;
  error?: string;
  remainingSeconds: number;
  hasUsableQrCode: boolean;
  title?: string;
};

export function ApprovalQrPanel({
  loading,
  qrCodeUrl,
  error,
  remainingSeconds,
  hasUsableQrCode,
  title = 'Autorizar por QR Code',
}: ApprovalQrPanelProps) {
  return (
    <div style={panelStyle}>
      <h3 style={titleStyle}>{title}</h3>
      <div style={qrFrameStyle}>
        {loading ? (
          <div style={qrPlaceholderStyle}>
            <Loader2 size={30} style={{ color: '#2563eb', animation: 'daw-spin 1s linear infinite' }} />
          </div>
        ) : (
          <StyledQrCode
            value={qrCodeUrl}
            size={320}
            width={320}
            height={320}
            shape="square"
            style="rounded"
            icon="logo-shield-qrcode-backing"
            iconKind="preset"
            iconSize={140}
            hideBackgroundDots={false}
            foreground="#7c3aed"
            background="#ffffff"
            margin={0}
          />
        )}
      </div>

      {error && (
        <p className="form-error-text" style={errorStyle}>
          {error}
        </p>
      )}

      {hasUsableQrCode && (
        <div style={{
          ...timerStyle,
          color: remainingSeconds <= 10 ? '#ef4444' : '#64748b',
        }}>
          QR valido por {formatCountdown(remainingSeconds)}
        </div>
      )}
    </div>
  );
}

const panelStyle: CSSProperties = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  paddingLeft: 24,
  borderLeft: '1px solid #f1f5f9',
  boxSizing: 'border-box',
  textAlign: 'center',
};

const titleStyle: CSSProperties = {
  fontSize: '0.98rem',
  fontWeight: 800,
  color: '#1e293b',
  margin: '0 0 10px',
};

const qrFrameStyle: CSSProperties = {
  background: '#f8fafc',
  padding: 6,
  borderRadius: 22,
  border: '1.5px dashed #cbd5e1',
  boxShadow: '0 8px 24px rgba(0,0,0,0.02)',
  display: 'inline-block',
};

const qrPlaceholderStyle: CSSProperties = {
  width: 320,
  height: 320,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const errorStyle: CSSProperties = {
  margin: '10px 0 0',
  maxWidth: 250,
};

const timerStyle: CSSProperties = {
  marginTop: 10,
  fontSize: '0.72rem',
  fontWeight: 800,
};
